export default __webpack_public_path__ + "static/media/card1.ecc3ac4a.jpeg";